import {getDARSettings, getDARSettingsCollapsedState} from './selectors'
import * as ActionTypes from './actionTypes'
import {createActionObject} from '../../redux/utils'
import * as SyncCallbacks from './syncCallbacks'
import {storeDARSettingsCollapsedState} from './utils'

const createOnChangedAction = (type) => {
    return val => (dispatch, getState) => {
        dispatch(createActionObject(type, val))
        SyncCallbacks.onDarSettingsChanged(getDARSettings(getState()))
    }
}

export const setAllowUsersToSeeAllTT = createOnChangedAction(ActionTypes.ALLOW_USERS_TO_SEE_ALL_TT_SET)
export const setUsersForSeeAllTTFilter = createOnChangedAction(ActionTypes.USERS_FOR_SEE_ALL_TT_FILTER_SET)
export const setShowUsernameInReports = createOnChangedAction(ActionTypes.SHOW_USERNAME_IN_REPORTS_SET)
export const setHideNotAssignedTTDetails = createOnChangedAction(ActionTypes.HIDE_NOT_ASSIGNED_TT_DETAILS_SET)
export const setHideDetailsOnLockTT = createOnChangedAction(ActionTypes.HIDE_DETAILS_ON_LOCK_TT_SET)
export const setHideAccountSettingsWhenDisabled = createOnChangedAction(ActionTypes.HIDE_ACCOUNT_SETTINGS_WHEN_DISABLED_SET)
export const setTTMCanSeeAutoApproved = createOnChangedAction(ActionTypes.TTM_CAN_SEE_AUTO_APPROVED_SET)

export const setAllowUsersToSeeAllTTCollapsed = (collapsed) => (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.ALLOW_USERS_TO_SEE_ALL_TT_COLLAPSE, collapsed))
    storeDARSettingsCollapsedState(getDARSettingsCollapsedState(getState()))
}

export const setShowUsernameInReportsCollapsed = (collapsed) => (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.SHOW_USERNAME_IN_REPORTS_COLLAPSE, collapsed))
    storeDARSettingsCollapsedState(getDARSettingsCollapsedState(getState()))
}

export const setHideNotAssignedTTDetailsCollapsed = (collapsed) => (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.HIDE_NOT_ASSIGNED_TT_DETAILS_COLLAPSE, collapsed))
    storeDARSettingsCollapsedState(getDARSettingsCollapsedState(getState()))
}

export const setHideDetailsOnLockTTCollapsed = (collapsed) => (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.HIDE_DETAILS_ON_LOCK_TT_COLLAPSE, collapsed))
    storeDARSettingsCollapsedState(getDARSettingsCollapsedState(getState()))
}

export const setHideAccountSettingsCollapsed = (collapsed) => (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.HIDE_ACCOUNT_SETTINGS_COLLAPSE, collapsed))
    storeDARSettingsCollapsedState(getDARSettingsCollapsedState(getState()))
}

export const setTtmCanSeeAutoApprovedCollapsed = (collapsed) => (dispatch, getState) => {
    dispatch(createActionObject(ActionTypes.TTM_CAN_SEE_AUTO_APPROVED_COLLAPSE, collapsed))
    storeDARSettingsCollapsedState(getDARSettingsCollapsedState(getState()))
}



// WEBPACK FOOTER //
// ./web/js/administration/darSettings/actions.js